import React from "react";
import Login from "../Layout/Login/Login";
import { useAuthentication } from "../../Hooks/useAuthentication";

const AuthGuard = ({ children }) => {
  const { isAuthenticated } = useAuthentication();

  if (!isAuthenticated) {
    return <Login />;
  }

  return children;
};

export default AuthGuard;
